/*
  Marisa Profumerie - 30/09/2026
  Segnaposto della barra di ricerca: "Cerca" fisso e accanto una parola che si scrive e si cancella da sola
  (Profumi, Make-up, Skincare). Parole in snippets/main-search.liquid (data-typing-prefix, data-typing-words).
  Si ferma quando si tocca la barra o c'è del testo; con "riduci animazioni" resta fisso sulla prima parola.
*/
(() => {
  const TYPE_MS = 110;
  const DELETE_MS = 55;
  const HOLD_MS = 1800;
  const GAP_MS = 350;
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const animate = (input) => {
    const prefix = (input.dataset.typingPrefix || 'Cerca').trim();
    const words = (input.dataset.typingWords || '').split('|').map((w) => w.trim()).filter(Boolean);
    if (!words.length) return;

    const show = (text) => input.setAttribute('placeholder', text ? `${prefix} ${text}` : prefix);
    if (reduceMotion) {
      show(words[0]);
      return;
    }

    let word = 0;
    let chars = 0;
    let deleting = false;
    let timer = null;

    const paused = () => document.activeElement === input || input.value !== '';

    const step = () => {
      if (paused()) {
        show(words[word]);
        timer = null;
        return;
      }
      const current = words[word];
      let delay = deleting ? DELETE_MS : TYPE_MS;
      if (!deleting) {
        chars++;
        if (chars >= current.length) {
          chars = current.length;
          deleting = true;
          delay = HOLD_MS;
        }
      } else {
        chars--;
        if (chars <= 0) {
          chars = 0;
          deleting = false;
          word = (word + 1) % words.length;
          delay = GAP_MS;
        }
      }
      show(current.slice(0, chars));
      timer = setTimeout(step, delay);
    };

    const resume = () => {
      if (timer || paused()) return;
      chars = 0;
      deleting = false;
      timer = setTimeout(step, GAP_MS);
    };

    input.addEventListener('focus', () => show(words[word]));
    input.addEventListener('blur', resume);
    input.addEventListener('input', () => {
      if (input.value === '' && document.activeElement !== input) resume();
    });

    show('');
    timer = setTimeout(step, GAP_MS);
  };

  const start = () => document.querySelectorAll('input[data-typing-words]').forEach(animate);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
